/* eslint-disable no-unused-labels */
import store from "@/store"
import { utils } from "@/store/helpers"
import { getServiceTitle } from "@/views/dashboard/admin/integrations/ml.js"

class ObjectType {
  constructor(type) {
    if (!type) {
      return
    }
    if (typeof type === "object") {
      this.object_type = type
    } else {
      this.object_type = store.state.object_types.find((m) => m.type == type)
    }
    this.type = this.object_type.type
    this.datetime_created = this.object_type?.datetime_created
    this.description = this.object_type?.description
    this.hyper_linked_metrics = this.object_type?.hyper_linked_metrics
    this.id = this.object_type?.id
    this.is_removed = this.object_type?.is_removed
    this.label = this.object_type?.label
    this.last_edited = this.object_type?.last_edited
    this.name = this.object_type?.name
    this.origins_types = this.object_type?.origins_types
    this.parent = this.object_type?.parent
    this.plural_label = this.object_type?.plural_label || utils.nounHelper.toPlural(this.object_type?.label || this.object_type.type)
    this.metrics = store.state.metrics.filter((m) => m.object_type == this.type)
    this.origin = this.object_type?.origins_types.find((o) => o.is_direct)?.origin || "Local"
    this.origin_object_name = this.object_type?.origins_types.find((o) => o.is_direct)?.type || this.type
    this.integration = store.state.integration.integrations.find((i) => i.origin == this.origin)
    this.origin_title = this.integration ? this.integration.title : getServiceTitle(this.origin)
  }

  get pretty_name() {
    return `${this.label}${this.origin ? ` (${this.origin})` : ""}`
  }

  get getTotalMetricCount() {
    return this.metrics.length
  }
  static getObjectTypeMetricsCount = (type) => {
    return store.state.metrics.filter((m) => m.object_type == type).length
  }
  static sortedByMetricCount = () => {
    return [...store.state.object_types].sort((a, b) => {
      return ObjectType.getObjectTypeMetricsCount(b.type) - ObjectType.getObjectTypeMetricsCount(a.type)
    })
  }

  static of = (type) => {
    if (typeof type === "object") {
      return new ObjectType(type.type)
    } else {
      return new ObjectType(store.state.object_types.find((m) => m.type == type)?.type)
    }
  }
}

export { ObjectType }
